// Auth-aware fetch for the Tether dashboard.
//
// Components across the app call window.fetch directly with `${API}/...`
// URLs, so instead of rewriting every call site we patch fetch once:
//  • attaches the tenant's bearer token to API requests
//  • broadcasts `tether:logout` when the backend answers 401 so the app
//    can drop straight back to the login screen
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_PREFIX = `${BACKEND_URL}/api`;

export const AUTH_TOKEN_KEY = 'tether_auth';
export const ME_KEY = 'tether_me';

export function getStoredMe() {
  try {
    return JSON.parse(localStorage.getItem(ME_KEY) || 'null');
  } catch {
    return null;
  }
}

export function installAuthFetch() {
  if (window.__tetherFetchPatched) return;
  window.__tetherFetchPatched = true;

  const rawFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isApi = url.startsWith(API_PREFIX);
    const isLogin = url.startsWith(`${API_PREFIX}/auth/login`);

    if (isApi && !isLogin) {
      const token = localStorage.getItem(AUTH_TOKEN_KEY);
      const callerHeaders = (init && init.headers) || {};
      const callerHasAuth = Object.keys(callerHeaders).some(h => h.toLowerCase() === 'authorization');
      // Caller-supplied Authorization always wins (admin picker uses its own token)
      if (token && !callerHasAuth) {
        init = { ...(init || {}), headers: { ...callerHeaders, Authorization: `Bearer ${token}` } };
      }
    }

    const res = await rawFetch(input, init);

    if (isApi && !isLogin && res.status === 401) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      localStorage.removeItem(ME_KEY);
      window.dispatchEvent(new Event('tether:logout'));
    }
    return res;
  };
}
